import * as React from 'react';

export interface ISound {
    external_url_small: string;
    title: string;
}

export interface ISoundsProps {
    sounds?: ISound[];
}

export const Sounds: React.FunctionComponent<ISoundsProps> = props => {
    const { sounds } = props;
    let external_url_small = '';

    return (
        <>
            {
                sounds.map(sound => {
                    external_url_small = (sound.external_url_small).endsWith('.mp3') ? `${sound.external_url_small}` : `${sound.external_url_small}.mp3`;
                    return <React.Fragment key={sound.external_url_small}>
                        <h4>{sound.title}</h4>
                        <audio controls preload="none" aria-label={sound.title}>
                            <source src={external_url_small} type="audio/mpeg" />
                        </audio>
                    </React.Fragment>;
                })
            }
        </>
    );
}
